import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { Field } from "react-final-form";
import { MultipleSuggestedInput } from "@vk-hr-tek/ui/input";
import { compose } from "../validation/index.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function MultipleSuggestedInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else MultipleSuggestedInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const handleChange = (input, onChange)=>(value)=>{
        input.onChange(value);
        if (onChange) onChange(value);
    };
const MultipleSuggestedInput_MultipleSuggestedInput = (props)=>{
    const $ = c(48);
    let helperText;
    let label;
    let labelIcon;
    let name;
    let onChange;
    let placeholder;
    let renderOption;
    let rest;
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let tooltip;
    let validate;
    if ($[0] !== props) {
        const { type, name: t9, label: t10, labelIcon: t11, onChange: t12, placeholder: t13, disabled: t14, required: t15, clearable: t16, loading: t17, tooltip: t18, helperText: t19, renderOption: t20, limit: t21, minInputValueLength: t22, minInputValueLengthForRequest: t23, validate: t24, validationWithoutTouch: t25, validationWhenDisabled: t26 } = props, t27 = _object_without_properties(props, [
            "type",
            "name",
            "label",
            "labelIcon",
            "onChange",
            "placeholder",
            "disabled",
            "required",
            "clearable",
            "loading",
            "tooltip",
            "helperText",
            "renderOption",
            "limit",
            "minInputValueLength",
            "minInputValueLengthForRequest",
            "validate",
            "validationWithoutTouch",
            "validationWhenDisabled"
        ]);
        name = t9;
        label = t10;
        labelIcon = t11;
        onChange = t12;
        placeholder = t13;
        t0 = t14;
        t1 = t15;
        t2 = t16;
        t3 = t17;
        tooltip = t18;
        helperText = t19;
        renderOption = t20;
        t4 = t21;
        t5 = t22;
        t6 = t23;
        validate = t24;
        t7 = t25;
        t8 = t26;
        rest = t27;
        $[0] = props;
        $[1] = helperText;
        $[2] = label;
        $[3] = labelIcon;
        $[4] = name;
        $[5] = onChange;
        $[6] = placeholder;
        $[7] = renderOption;
        $[8] = rest;
        $[9] = t0;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
        $[17] = t8;
        $[18] = tooltip;
        $[19] = validate;
    } else {
        helperText = $[1];
        label = $[2];
        labelIcon = $[3];
        name = $[4];
        onChange = $[5];
        placeholder = $[6];
        renderOption = $[7];
        rest = $[8];
        t0 = $[9];
        t1 = $[10];
        t2 = $[11];
        t3 = $[12];
        t4 = $[13];
        t5 = $[14];
        t6 = $[15];
        t7 = $[16];
        t8 = $[17];
        tooltip = $[18];
        validate = $[19];
    }
    const disabled = void 0 === t0 ? false : t0;
    const required = void 0 === t1 ? false : t1;
    const clearable = void 0 === t2 ? false : t2;
    const loading = void 0 === t3 ? false : t3;
    const limit = void 0 === t4 ? 50 : t4;
    const minInputValueLength = void 0 === t5 ? 1 : t5;
    const minInputValueLengthForRequest = void 0 === t6 ? minInputValueLength : t6;
    const validationWithoutTouch = void 0 === t7 ? false : t7;
    const validationWhenDisabled = void 0 === t8 ? false : t8;
    let t9;
    if ($[20] !== validate) {
        t9 = Array.isArray(validate) ? compose(validate) : validate;
        $[20] = validate;
        $[21] = t9;
    } else t9 = $[21];
    let t10;
    if ($[22] !== clearable || $[23] !== disabled || $[24] !== helperText || $[25] !== label || $[26] !== labelIcon || $[27] !== limit || $[28] !== loading || $[29] !== minInputValueLength || $[30] !== minInputValueLengthForRequest || $[31] !== onChange || $[32] !== placeholder || $[33] !== props.externalItems || $[34] !== props.loadItems || $[35] !== props.mask || $[36] !== props.type || $[37] !== renderOption || $[38] !== required || $[39] !== tooltip || $[40] !== validationWhenDisabled || $[41] !== validationWithoutTouch) {
        t10 = (t11)=>{
            const { input, meta } = t11;
            const errorDisabled = disabled || !validationWhenDisabled;
            const renderError = !errorDisabled && validationWithoutTouch ? !!input.value && !!meta.error : meta.touched && !!meta.error;
            const baseInputProps = _object_spread_props(_object_spread({}, input), {
                label,
                labelIcon,
                onChange: handleChange(input, onChange),
                placeholder,
                disabled,
                required,
                clearable,
                loading,
                tooltip,
                error: renderError,
                helperText: renderError && meta.error || helperText,
                renderOption,
                limit,
                minInputValueLength,
                minInputValueLengthForRequest
            });
            return "load" === props.type ? /*#__PURE__*/ jsx(MultipleSuggestedInput, _object_spread_props(_object_spread({}, baseInputProps), {
                type: "load",
                loadItems: props.loadItems,
                mask: props.mask
            })) : /*#__PURE__*/ jsx(MultipleSuggestedInput, _object_spread_props(_object_spread({}, baseInputProps), {
                type: "local",
                externalItems: props.externalItems
            }));
        };
        $[22] = clearable;
        $[23] = disabled;
        $[24] = helperText;
        $[25] = label;
        $[26] = labelIcon;
        $[27] = limit;
        $[28] = loading;
        $[29] = minInputValueLength;
        $[30] = minInputValueLengthForRequest;
        $[31] = onChange;
        $[32] = placeholder;
        $[33] = props.externalItems;
        $[34] = props.loadItems;
        $[35] = props.mask;
        $[36] = props.type;
        $[37] = renderOption;
        $[38] = required;
        $[39] = tooltip;
        $[40] = validationWhenDisabled;
        $[41] = validationWithoutTouch;
        $[42] = t10;
    } else t10 = $[42];
    let t11;
    if ($[43] !== name || $[44] !== rest || $[45] !== t10 || $[46] !== t9) {
        t11 = /*#__PURE__*/ jsx(Field, _object_spread_props(_object_spread({
            name: name
        }, rest), {
            validate: t9,
            children: t10
        }));
        $[43] = name;
        $[44] = rest;
        $[45] = t10;
        $[46] = t9;
        $[47] = t11;
    } else t11 = $[47];
    return t11;
};
export { MultipleSuggestedInput_MultipleSuggestedInput as MultipleSuggestedInput };
